import { animation } from '@/services/animation';

    // ALERTS
        export function alerts($action=0, $txt='', $varios=0, $delay=0)
        {
            if(!$delay){
                $delay = 5;
                if($action){
                    $delay = 3;
                }
            }

            if(!$varios){
                document.querySelectorAll('.__EVENTS__ .alerts .alert').forEach($item => $item.style.display = 'none');
            }

            if(!$txt){
                $txt = $action ? 'Operação Realizada com Sucesso!' : 'Ocorreu algum erro inesperado!';
            }

            let $rand = parseInt(Math.random()*10000000);
            let $html  = ``;
            $html += `<div class="c-p action_${$action ? 1 : 0} alert alert_${$rand}"> `;
                $html += `<div>${$txt}</div> `;
            $html += `</div> `;

            document.querySelector('.__EVENTS__ .alerts').insertAdjacentHTML('beforeend', $html);
            animation(`.__EVENTS__ .alerts .alert_${$rand}`, 'fadeInOut', $delay);

            document.querySelectorAll(`.__EVENTS__ .alert.alert_${$rand}`).forEach($item_1 => {
                $item_1.addEventListener('click', () => {
                    animation(`.__EVENTS__ .alerts .alert_${$rand}`, 'fadeOut', $delay);
                });
            })
        }
    // ALERTS